export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const UNSUBSCRIBE_GET_ALL_NOTIFICATIONS = "UNSUBSCRIBE_GET_ALL_NOTIFICATIONS";
